export default function (string) {
  return (string && typeof string === 'string')
    ? string.replace('_', '')
    : string
}
